const ProgressService = function () {
  this.saveProgress = function (model, page, cb) {
    const act = typeof page.activity !== 'undefined';
    const ind = typeof page.get('index') !== 'undefined';
    const key = typeof page.get('key') !== 'undefined';
    if (act && ind && key) {
      model.get('module').setLastCompletedPage(page);
    }
    if (cb) {
      cb();
    }
  };

  this.getPath = function (eid) {
    return `/sdk/enrollments/${eid}/page_progresses.json`;
  };

  this.getRequestOptions = function (request) {
    return {
      dataType: 'json',
      type: 'POST',
      url: request.url,
      data: request.data,
    };
  };

  this.saveActivityProgress = function (model, grade, attempt, slug) {
    model.saveActivityProgress(grade, attempt, slug);
  };
};

export default new ProgressService();
